import * as console from "./platforms/console.ts";
import * as sentry from "./platforms/sentry.ts";
import type { IPlatform } from "./types.ts";

export default { console, sentry } satisfies Record<string, IPlatform<never>>;
